import React, { lazy } from 'react'
import CommonColorPicker from './CommonColorPicker.jsx';
import withSuspense from '../../../helpers/withSuspense.jsx'
import InputSkeleton from '../../../skeleton_loaders/common/InputSkeleton.jsx';
const Button = withSuspense(lazy(() => import('../../bootstrap/Button.jsx'), InputSkeleton));
import styles from './CommonColorPicker.module.scss';
import { FaIcon } from '../Icons.jsx';

const RepeatableColorPicker = ({ value, onChange, palette, paletteTitle }) => {
  const items = Array.isArray(value) ? value : []

  const handleChange = (idx, newColor) => {
    const next = [...items]
    next[idx] = newColor
    onChange(next)
  }

  const addColor = () => {
    onChange([...items, '#ffffff'])
  }

  const removeColor = idx => {
    onChange(items.filter((_, i) => i !== idx))
  }

  return (
    <div className={styles['repeatable-color-picker']}>
      {items.map((color, idx) => (
        <div key={idx} className={styles['color-item']}>
          <CommonColorPicker
            value={color}
            onChange={newColor => handleChange(idx, newColor)}
            paletteTitle={paletteTitle}
            palette={palette}
          />
          <a onClick={() => removeColor(idx)}>
            <FaIcon type='trash' className='text-danger' />
          </a>
        </div>
      ))}
      <Button size='sm' onClick={addColor}>
        <FaIcon type='plus' /> {I18n.t('add_color')}
      </Button>
    </div>
  )
}

export default RepeatableColorPicker
